import * as yup from 'yup'

const schema = ({ isCreate, isEdit, addMetric }) => {
  if (addMetric) {
    return yup.object({
      value: yup.number().nullable().required(),
      observation: yup.string(),
    })
  }
  if (isCreate || isEdit) {
    return yup.object({
      value: yup.number().nullable().required(),
      period: yup.mixed().nullable().required(),
      status: yup.mixed().nullable().required(),
      date: yup
        .mixed()
        .nullable()
        .required()
        .test(
          'same-month-year-as-period',
          'O mês e ano devem ser iguais ao Período de Referência',
          function (value) {
            const { period } = this.parent
            if (!value || !period) return true

            const getMonthYear = (val, format) => {
              if (val instanceof Date) {
                return { month: val.getMonth() + 1, year: val.getFullYear() }
              }
              if (typeof val === 'string') {
                const parts = val.split('/')
                if (format === 'MM/yyyy' && parts.length === 2) {
                  return { month: parseInt(parts[0]), year: parseInt(parts[1]) }
                }
                if (format === 'DD/MM/yyyy' && parts.length === 3) {
                  return { month: parseInt(parts[1]), year: parseInt(parts[2]) }
                }
              }
              const d = new Date(val)
              return { month: d.getMonth() + 1, year: d.getFullYear() }
            }

            const dateMonthYear = getMonthYear(value, 'DD/MM/yyyy')
            const periodMonthYear = getMonthYear(period, 'MM/yyyy')

            return (
              dateMonthYear.month === periodMonthYear.month &&
              dateMonthYear.year === periodMonthYear.year
            )
          },
        ),
      observation: yup.string(),
      attachments: yup.mixed().fileUpload(),
    })
  }
  return yup.object({})
}

export default schema
